import { AnimatePresence, motion } from 'framer-motion';

// App theme: teal (primary), blue (secondary), lime (accent), light blue, white.
const COLORS = ['#63dab9', '#5184b3', '#cdf564', '#599ac9', '#ffffff'];
const PARTICLES = 16;

interface CounterBurstProps {
  // Changes each time the counter ticks up; a new value triggers a fresh burst.
  triggerKey: number;
}

/**
 * A short confetti-style burst of particles flying outward from the centre.
 * Re-mounts (via `triggerKey`) so each signup fires a fresh celebration.
 */
export function CounterBurst({ triggerKey }: CounterBurstProps) {
  return (
    <AnimatePresence mode="wait">
      {triggerKey > 0 && (
        <motion.div
          key={triggerKey}
          className="pointer-events-none absolute inset-0 flex items-center justify-center"
        >
          {Array.from({ length: PARTICLES }).map((_, i) => {
            const angle = (i / PARTICLES) * Math.PI * 2;
            const distance = 120 + Math.random() * 120;
            return (
              <motion.span
                // biome-ignore lint/suspicious/noArrayIndexKey: static burst set
                key={i}
                className="absolute h-2.5 w-2.5 rounded-full"
                style={{ backgroundColor: COLORS[i % COLORS.length] }}
                initial={{ opacity: 1, scale: 1, x: 0, y: 0 }}
                animate={{
                  opacity: 0,
                  scale: 0.4,
                  x: Math.cos(angle) * distance,
                  y: Math.sin(angle) * distance,
                }}
                transition={{ duration: 0.9, ease: 'easeOut' }}
              />
            );
          })}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
